import { useEffect, useRef } from 'react'

//components
import Row from "./Row"
import Pagination from "components/app/components/Pagination"

//providers
import { useStudentsDataContext } from "../_providers/Students"
import { useAppContext } from 'providers/App'

//modals
import Remove from "components/modals/Remove"

const Table = () => {
    const app = useAppContext()
    const removeStudentModalRef = useRef()
    const studentsData = useStudentsDataContext()
    const handlePage = page => {
        studentsData.handleStudents()._set()._filter('page', String(page.selected + 1))
    }

    useEffect(() => {
        if (Object.keys(studentsData.remove).length) removeStudentModalRef.current.open()
        else removeStudentModalRef.current.close()
    }, [studentsData.remove])



    return (
        <>
            <Remove
                ref={removeStudentModalRef}
                elementsContent={{
                    heading: `Искате ли да премахнете "${studentsData.remove.name}"?`,
                    buttons: {
                        accept: 'Премахни ученика'
                    }
                }}
                accept={async () => {
                    await studentsData.handleStudents()._remove()._process()
                    removeStudentModalRef.current.close()
                    studentsData.handleStudents()._remove()._reset()
                    app.handleMessage()._success()._show('Ученикът беше изтрит успешно!')
                }}
                cancel={studentsData.handleStudents()._remove()._reset}
            />
            <table cellSpacing="0" cellPadding="0">
                <thead>
                    <tr>
                        <th>
                            #
                        </th>
                        <th>
                            Потребител
                        </th>
                        <th>
                            Клас
                        </th>
                        <th>
                            Форма на обучение
                        </th>
                        <th>
                            Прогрес
                        </th>
                        <th className="centered">
                            Опции
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {studentsData.handleStudents()._get()._list().map((l, i) =>
                        <Row
                            key={`student-${l.id}`}
                            data={l}
                            index={i}
                        />
                    )}
                </tbody>
            </table>
            <Pagination
                page={studentsData.filter.page}
                pages={studentsData.data.pages}
                handlePage={handlePage}
            />
        </>
    )
}

export default Table